module.exports = __webpack_public_path__ + "static/media/visal-logo-big.b0616ac2.png";